"use client"

import type { ReactNode } from "react"

export interface SidebarSubContentProps {
  children: ReactNode
  title?: string
}

export function SidebarSubContent({ children, title }: SidebarSubContentProps) {
  return null
}

SidebarSubContent.displayName = "SidebarSubContent"
